import { creating, exist, Id } from '@campaign-portal/namespace/common/id';
import { MORoute } from '@campaign-portal/namespace/entities/mo-routes/specs';

export type MORouteEntityConfig<ID = exist | creating> = Partial<MORoute<ID>>;

export class MORouteEntity<ID = exist | creating> implements MORoute<ID> {
	readonly id: ID;
	readonly url: string;
	readonly senderIds: Id<exist>[];

	readonly creationDate?: string | null;
	readonly createdBy?: string | null;
	readonly lastUpdated?: string | null;
	readonly modifiedBy?: string | null;

	constructor(config?: MORouteEntityConfig<ID>) {
		this.id = config?.id ?? (null as ID);
		this.url = config?.url ?? '';
		this.senderIds = config?.senderIds ?? [];
		this.creationDate = config?.creationDate;
		this.createdBy = config?.createdBy;
		this.lastUpdated = config?.lastUpdated;
		this.modifiedBy = config?.modifiedBy;
	}
}
